import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tir-pm-kanban-card" }
const _hoisted_2 = { class: "tir-pm-kanban-card__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-kanban-card__name" }, " Название задачи, умещается в две строки. Но может быть любой длины. Как, например, здесь ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-kanban-card__queue-name" }, "Очередь: Название очереди", -1)
const _hoisted_5 = { class: "tir-pm-kanban-card__description-block" }
const _hoisted_6 = { class: "tir-pm-kanban-card__description-icon" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-kanban-card__description-text" }, null, -1)
const _hoisted_8 = { class: "tir-pm-kanban-card__divider" }
const _hoisted_9 = { class: "tir-pm-kanban-card__body" }
const _hoisted_10 = { class: "tir-pm-kanban-card__users-block" }
const _hoisted_11 = { class: "tir-pm-kanban-card__users-icon" }
const _hoisted_12 = { class: "tir-pm-kanban-card__users-list" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.75rem","line-height":"1rem","font-weight":"500"} }, "ГР", -1)
const _hoisted_14 = { class: "tir-pm-kanban-card__priority-block" }
const _hoisted_15 = { class: "tir-pm-kanban-card__priority-icon" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-kanban-card__priority-list" }, null, -1)
const _hoisted_17 = { class: "tir-pm-kanban-card__tags-block" }
const _hoisted_18 = { class: "tir-pm-kanban-card__tags-icon" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-kanban-card__tags-list" }, null, -1)
const _hoisted_20 = { class: "tir-pm-kanban-card__inner-task-indicator tir-pm-kanban-card__inner-task-indicator--activate" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-kanban-card__inner-task-count" }, "Вложенных задач: 2", -1)
const _hoisted_22 = { class: "tir-pm-kanban-card__inner-task-icon" }

import { TirPmTag, TirPmTagSizeEnum } from "tir-pm-tag";
import { TirDivider } from "tir-pm-divider";
import { FlagIcon, TagIcon, UserCircleIcon } from "tir-style-system/icons/outline";
import { Bars3BottomLeftIcon, ShareIcon } from "tir-style-system/icons/solid";
import { PropType } from "vue";

import { TirPmIconView } from "tir-pm-icon-view";

// const slots = useSlots();

// /**
//  * Есть ли слот для иконки слева
//  */
// const isLeftAddon = computed(() => slots && slots.leftAddon && slots.leftAddon());
// /**
//  * Есть ли слот для кнотролов, кнопок справа
//  */
// const isRightControls = computed(() => slots && slots.rightControls && slots.rightControls());
// /**
// //  * Есть ли конент
// //  */
// // const contentSlot = computed(() => slots && slots.content && slots.content());
// // console.log(contentSlot.value);

// let fileUpload = ref(null);
// /**
//  * Пропсы
//  */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmKanbanCard',
  props: {
  /**
   * Имя файла
   */
  fileName: {
    type: String as PropType<string | null | undefined>,
    default: "File name",
  },
  /**
   * Процент загрузки
   */
  percent: {
    type: String as PropType<string | null | undefined>,
    default: null,
  },
  /**
   * Размер файла
   */
  fileSize: {
    type: String as PropType<string | null | undefined>,
    default: null,
  },
  /**
   * Дата загрузки
   */
  dateUpload: { type: String as PropType<string | null | undefined>, default: null },
  /**
   * Список предупреждений и состояний
   */
  stateUploadList: {
    type: Object as PropType<Array<{ variant: "default" | "error"; text: string }>>,
    default() {
      return [];
    },
  },
  withBorder: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Bars3BottomLeftIcon))
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(TirDivider))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(UserCircleIcon))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createVNode(_unref(TirPmIconView), {
                size: 24,
                isRounded: ""
              }, {
                mainSlot: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(FlagIcon))
          ]),
          _hoisted_16
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_unref(TagIcon))
          ]),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_unref(ShareIcon))
          ])
        ])
      ])
    ])
  ]))
}
}

})